import { formatCPF, getCPFDigits } from '@/lib/cpf';
import { formatPhoneNumber, getPhoneNumberDigits } from '@/lib/phoneNumber';
import type { User } from '@/types/domain/user';
import type { UpdateProfileRequestDto } from '@/types/dto/profile.dto';
import type { EditableProfileValues } from '@/types/profile';

function normalizeText(value?: string | null) {
  return value?.trim() ?? '';
}

function normalizeBirthDate(value?: string | null) {
  const normalizedValue = normalizeText(value);

  if (!normalizedValue) {
    return '';
  }

  return normalizedValue.slice(0, 10);
}

export function getEditableProfileValues(user?: User | null): EditableProfileValues {
  return {
    birthDate: normalizeBirthDate(user?.birthDate),
    email: normalizeText(user?.email),
    name: normalizeText(user?.name),
    phoneNumber: formatPhoneNumber(user?.phoneNumber),
    socialNumber: formatCPF(user?.socialNumber),
  };
}

export function buildProfileUpdatePayload(values: EditableProfileValues): UpdateProfileRequestDto {
  const birthDate = normalizeBirthDate(values.birthDate);
  const email = normalizeText(values.email);
  const fullName = normalizeText(values.name);
  const phoneNumber = getPhoneNumberDigits(values.phoneNumber);
  const socialNumber = getCPFDigits(values.socialNumber);

  return {
    ...(birthDate ? { birthDate } : {}),
    ...(email ? { email } : {}),
    ...(fullName ? { fullName } : {}),
    ...(phoneNumber ? { phoneNumber } : {}),
    ...(socialNumber ? { socialNumber } : {}),
  };
}
